function patternMatching(cases, fallback) {
  return (value) => {
    for (const [$case, $return] of cases) {
      if ($case === value) {
        return $return;
      }
    }

    if (fallback) {
      return fallback;
    } else {
      return undefined;
    }
  };
}

export default patternMatching;
